function captcha() {
	var submitForm = function (widgetId, formId) {
		// submit the form which now includes a g-recaptcha-response input
		if (isCaptchaChecked(widgetId)) {
			$("#" + formId).submit();
			$("#" + formId + " button").prop("disabled", true);
		}
	};

	var submitFormOptOut = function (widgetId, formId) {
		if (isCaptchaChecked(widgetId)) {
			$("#" + formId).submit();
			grecaptcha.reset(widgetId);
		}
	};

	var isCaptchaChecked = function (widgetId) {
		return grecaptcha && grecaptcha.getResponse(widgetId).length !== 0;
	};

	var renderInvisibleReCaptcha = function (reCaptchaId, callbackFunction) {
		return grecaptcha.render(reCaptchaId, {
			sitekey: "6LfyIT8UAAAAACaBHOc5rM8F7iau2QV4fkMn4hYn",
			callback: callbackFunction,
			size: "invisible",
			badge: "inline",
		});
	};

	window.register = function (event) {
		event.preventDefault();
		grecaptcha.execute(registerWidgetId);
	};

	window.sendQuestion = function (event) {
		event.preventDefault();
		grecaptcha.execute(sendQuestionWidgetId);
	};

	window.sendBrief = function (event) {
		event.preventDefault();
		grecaptcha.execute(sendBriefWidgetId);
	};

	window.sendOptOut = function (event) {
		event.preventDefault();
		grecaptcha.execute(sendOptOutWidgetId);
	};

	window.onloadCallback = function () {
		if ($("#register-form-captcha").length) {
			window.registerWidgetId = renderInvisibleReCaptcha(
				"register-form-captcha",
				function (token) {
					var formId = $("#register-form-captcha").closest("form").attr("id");
					submitForm(registerWidgetId, formId);
				}
			);
		}

		if ($("#send-question-form-captcha").length) {
			window.sendQuestionWidgetId = renderInvisibleReCaptcha(
				"send-question-form-captcha",
				function (token) {
					var formId = $("#send-question-form-captcha")
						.closest("form")
						.attr("id");
					submitForm(sendQuestionWidgetId, formId);
				}
			);
		}

		if ($("#tasil-plus-form-captcha").length) {
			window.sendBriefWidgetId = renderInvisibleReCaptcha(
				"tasil-plus-form-captcha",
				function (token) {
					var formId = $("#tasil-plus-form-captcha").closest("form").attr("id");
					submitForm(sendBriefWidgetId, formId);
				}
			);
		}

		if ($("#opt-out-form-captcha").length) {
			window.sendOptOutWidgetId = renderInvisibleReCaptcha(
				"opt-out-form-captcha",
				function (token) {
					var formId = $("#opt-out-form-captcha").closest("form").attr("id");
					submitFormOptOut(sendOptOutWidgetId, formId);
				}
			);
		}
	};
}
